// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';

type Props = {
  delay?: number,
  text?: string,
};

type State = {
  showLoader: boolean,
};

export default class LoadingAsync extends React.Component<Props, State> {
  state = {
    showLoader: false,
  };

  static defaultProps = {
    delay: 300,
    text: 'Loading',
  };

  timer: TimeoutID;

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({
        showLoader: true,
      });
    }, this.props.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    if (this.state.showLoader)
      return (
        <div
          css={{
            textAlign: 'center',
            background: 'rgba(20, 156, 130, 0.6)',
            color: 'white',
            padding: '5px',
            margin: '5px 0',
          }}
        >
          {this.props.text}
        </div>
      );

    return null;
  }
}
